import styled from 'styled-components';

export const SearchBannerSection = styled.div`
   padding:60px 0; 
   position: relative;
    @media screen and (max-width:1166px) {
      margin-top:100px;   
    }
   &:after { 
        position: absolute;
        background: #F1FEFF 0% 0% no-repeat padding-box; 
        width: 100%;
        height: 50%;
        content: "";
        bottom: 0;
        z-index: -1;
  }
    
`;
export const SearchBanner = styled.div`
    display: flex;
    gap:24px;
`;
export const LeftBanner = styled.div`
    width: 100%;
    max-width: 690px;
`;
export const LogoTitle = styled.div`
    display: flex;
    gap:15px;
`;
export const LogoImage = styled.div`
    background: #F7F7F7;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 10px;
    opacity: 1;
    width: 120px;
    min-width:120px;
    height: 120px;

    img{
        width:100%;
    } 
`;
export const TitleSection = styled.div`

`;

export const RightBanner = styled.div`
    width: 100%;
    max-width: 486px;
    
    .image-gallery-left-nav,
    .image-gallery-right-nav,
    .image-gallery-fullscreen-button{
        display:none;
    }

   .image-gallery-slide-wrapper {
        background: #FFFFFF;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 10px;
        padding: 10px;
    }

    .image-gallery-thumbnail.active,
    .image-gallery-thumbnail:focus {
        outline: none;
        border: 4px solid #337ab7;
        border: 2px solid #FFFFFF;
        border-radius: 10px !important;
        opacity: 1;
    }

    .image-gallery-thumbnails {
      background: #211d1a;
        border-radius: 10px;
        opacity: 1;
        backdrop-filter: blur(50px);
        -webkit-backdrop-filter: blur(50px);
        max-width: 453px;
        width: 100%;
        padding: 9px 8px;
       margin: -100px auto 0px;
    }
    .image-gallery-thumbnail-image{
        border-radius: 10px !important; 
        height: 55px;  

    }

    .image-gallery-thumbnail{
        width: 70px;
        height: 59px;
        min-width: 70px;
        border: 2px solid transparent;
        border-radius: 10px;
        opacity: 0.8;
        &:hover {
            outline: none;
            border: 2px solid #fff;
            border-radius: 10px;
        }
    }
`;
export const SearchTitle = styled.h1`
    color: #333333;;
    font-family: "Jost", sans-serif;
    font-size:22px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 15px;

`;

export const WarmCost = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 15px;
    display: flex;
    align-items: center;
    padding: 18px 15px;
    margin-top: 40px;
    gap: 32px;
`;
export const WarmCoastTile = styled.h2`
   color: #33A7AE;
   font-family: "Jost", sans-serif;
   font-size:20px;
   font-weight: 600;
   line-height:30px;
   margin-bottom:5px;
`;
export const SmallText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height:22px;
`;

export const WarmCostLeft = styled.div`
    width: 100%;
    max-width: 318px;
    position: relative;
    &:after {
        position: absolute;
        background: #E1E1E1;
        height: 100%;
        width: 2px;
        content: "";
        right: -17px;
        top: 0;
    }
`;

export const WarnCostRight = styled.div`
    flex:1;
`;

export const OtherBtn = styled.div`
     color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    // background:#01606F ;
    box-shadow: 0px 5px 10px #0000000D;
    background: rgb(51 167 174 / 10%);
    border-radius: 10px;
    padding: 14px 16px;
    display: inline-flex;
    max-width: 56px;
    text-align: center;
    justify-content: center;
`;

export const DollarWrapper = styled.div`
    display: flex;
    gap: 9px;
    flex-wrap: wrap;
`;

export const NonprofitSection = styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding-bottom:20px;

    .pagination-wrapper{
        margin-top: 30px;
    }

    span.RatingReview{
        display: none;
    }

    .rating-star {
        img{
            width: 18px;
            height: 18px;
            display: block;
            object-fit: contain;
            margin-top: 0px;
        }
    }
`;




























